
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './styles/MetricCard.css';
import CircularProgress from './CircularProgress';

const MetricCard = ({ title, icon: Icon, count = 0, color, total = 0 }) => {

    const porcentaje = useMemo(() => {
        if (!total || total === 0) return 0;
        return Math.round((count / total) * 100);
    }, [count, total]);

    return (
        <div className="light-intensity-card">
            <div className="light-intensity-header">
                <h3 className="light-intensity-title">{title}</h3>
                {Icon && <Icon className="light-intensity-icon" size={20} />}
            </div>

            <div className="light-intensity-progress">
                <CircularProgress
                    percentage={porcentaje}
                    color={color}
                    showLabels={false}
                />
            </div>

            {count > 0 && (
                <div className="light-intensity-value">
                    <span className="value-label">Cantidad</span>
                    <span className="value-number">{count}</span>
                </div>
            )}
        </div>
    );
};

MetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  count: PropTypes.number,
  color: PropTypes.string,
  total: PropTypes.number,
};

export default MetricCard;